import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { AlertCircle, ArrowLeft, RefreshCw } from "lucide-react";

export default function ErrorPage({ message, onRetry }) {
  const handleBack = () => {
    // Go back to landing page
    onRetry();
  };

  return (
    <div className="min-h-[100dvh] bg-[var(--sa-light)] safe-area-top safe-area-bottom">
      {/* Header with Logo */}
      <header className="bg-white shadow-sm">
        <div className="px-6 py-4 flex items-center justify-center">
          <img 
            src="/safety-assist-logo.png" 
            alt="SafetyAssist" 
            className="h-10 object-contain"
          />
        </div>
      </header>

      {/* Main Content */}
      <main className="px-6 py-12 animate-slide-up">
        <div className="max-w-md mx-auto">
          <Card className="p-8 bg-white shadow-lg border-0 rounded-2xl text-center">
            {/* Error Icon */}
            <div className="w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-6">
              <AlertCircle className="w-8 h-8 text-red-500" />
            </div>

            {/* Error Message */}
            <h1 className="text-xl font-bold text-[var(--sa-secondary)] mb-3">
              Objekt nicht gefunden
            </h1>
            <p className="text-gray-600 mb-8">
              {message || "Das angeforderte Objekt konnte nicht gefunden werden."}
            </p>

            {/* Actions */}
            <div className="space-y-3">
              <Button
                data-testid="retry-btn"
                onClick={onRetry}
                className="w-full h-12 bg-[var(--sa-primary)] hover:bg-[var(--sa-primary-dark)] text-white rounded-xl font-semibold btn-press"
              >
                <RefreshCw className="w-4 h-4 mr-2" />
                Erneut versuchen
              </Button>
              
              <Button
                variant="outline"
                onClick={handleBack}
                className="w-full h-12 border-gray-200 text-gray-600 rounded-xl font-semibold"
              >
                <ArrowLeft className="w-4 h-4 mr-2" />
                Zurück
              </Button>
            </div>
          </Card>

          {/* Help Text */}
          <div className="mt-8 p-4 bg-white rounded-xl border border-gray-100">
            <p className="text-sm text-gray-600 text-center">
              Stelle sicher, dass die ID korrekt ist und das Objekt existiert.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}
